const QuinaIcon: React.FC<{ size?: string }> = ({ size = "24px" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4499_5035)">
        <path
          d="M5 20H6.775C7.14795 19.9965 7.50916 19.8692 7.80192 19.6381C8.09468 19.407 8.30241 19.0853 8.3925 18.7233C8.48898 18.371 8.69856 18.0601 8.98901 17.8385C9.27945 17.6168 9.63467 17.4968 10 17.4968C10.3653 17.4968 10.7205 17.6168 11.011 17.8385C11.3014 18.0601 11.511 18.371 11.6075 18.7233C11.6976 19.0853 11.9053 19.407 12.1981 19.6381C12.4908 19.8692 12.8521 19.9965 13.225 20H15C15.663 20 16.2989 19.7366 16.7678 19.2678C17.2366 18.7989 17.5 18.163 17.5 17.5V14.1667H14.1667C13.9457 14.1667 13.7337 14.0789 13.5774 13.9226C13.4211 13.7663 13.3333 13.5543 13.3333 13.3333C13.3333 13.1123 13.4211 12.9004 13.5774 12.7441C13.7337 12.5878 13.9457 12.5 14.1667 12.5H17.5V4.16667C17.4987 3.062 17.0593 2.00297 16.2782 1.22185C15.497 0.440735 14.438 0.00132321 13.3333 0L13.225 0C12.8521 0.00354318 12.4908 0.130844 12.1981 0.361916C11.9053 0.592988 11.6976 0.914744 11.6075 1.27667C11.511 1.62903 11.3014 1.93994 11.011 2.16155C10.7205 2.38316 10.3653 2.5032 10 2.5032C9.63467 2.5032 9.27945 2.38316 8.98901 2.16155C8.69856 1.93994 8.48898 1.62903 8.3925 1.27667C8.30241 0.914744 8.09468 0.592988 7.80192 0.361916C7.50916 0.130844 7.14795 0.00354318 6.775 0L6.66667 0C5.562 0.00132321 4.50296 0.440735 3.72185 1.22185C2.94073 2.00297 2.50132 3.062 2.5 4.16667V12.5H5.83333C6.05435 12.5 6.26631 12.5878 6.42259 12.7441C6.57887 12.9004 6.66667 13.1123 6.66667 13.3333C6.66667 13.5543 6.57887 13.7663 6.42259 13.9226C6.26631 14.0789 6.05435 14.1667 5.83333 14.1667H2.5V17.5C2.5 18.163 2.76339 18.7989 3.23223 19.2678C3.70107 19.7366 4.33696 20 5 20ZM9.16667 12.5H10.8333C11.0543 12.5 11.2663 12.5878 11.4226 12.7441C11.5789 12.9004 11.6667 13.1123 11.6667 13.3333C11.6667 13.5543 11.5789 13.7663 11.4226 13.9226C11.2663 14.0789 11.0543 14.1667 10.8333 14.1667H9.16667C8.94565 14.1667 8.73369 14.0789 8.57741 13.9226C8.42113 13.7663 8.33333 13.5543 8.33333 13.3333C8.33333 13.1123 8.42113 12.9004 8.57741 12.7441C8.73369 12.5878 8.94565 12.5 9.16667 12.5Z"
          fill="url(#paint0_radial_4499_5035)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_4499_5035"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.3044 22.7497) rotate(-121.371) scale(23.0515 22.077)"
        >
          <stop stopColor="#C848FF" />
          <stop offset="1" stopColor="#DC80FF" />
        </radialGradient>
        <clipPath id="clip0_4499_5035">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default QuinaIcon;
